import { Component, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { Order } from '../../../../order/models/order';
import { UNDERSCORE } from '../../../utils/constant';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { PRODUCT_OPTIONS, ORDER_NUMBER_OPTIONS, WEIGHT_OPTIONS } from '../../../models/list';
import { GROSS, CUSTOMER, ARTICLE } from '../../../models/settings';
import { DimensionPipe } from '../../../pipes/format-dimension.pipe';
import { NumberPipe } from '../../../pipes/number.pipe';
import { OrderService } from '../../../../order/services/order.service';

@Component({
	selector: 'copo-result-order-card',
	templateUrl: './result-card-order.component.html',
	styleUrl: './result-card-order.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		MatIconModule,
		NumberPipe,
		DimensionPipe,
	],
})
export class ResultCardOrderComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() order!: Order;
	user: User;
	readonly UNDERSCORE = UNDERSCORE;
	productDisplay: keyof typeof PRODUCT_OPTIONS = ARTICLE;
	orderDisplay: keyof typeof ORDER_NUMBER_OPTIONS = CUSTOMER;
	weightDisplay: keyof typeof WEIGHT_OPTIONS = GROSS;

	constructor(
		private readonly userService: UserService,
		private readonly orderService: OrderService
	) {
		this.user = this.userService.user;
	}

	getProductName(order: Order) {
		return order.steelgradeDescription || UNDERSCORE;
	}

	getProductLabel() {
		return 'order.steelgrade';
	}

	getOrderName(order: Order) {
		return order.customerOrderNumber === ''
			? UNDERSCORE
			: `${ order.customerOrderNumber }/${ order.customerOrderItemNumber }`;
	}

	getQuantity(order: Order, quantityName: string) {
		const qtyOrdered = order.grossQtyOrdered;
		const qtyInProduction = order.grossQtyInProduction;
		const qtyAvailableReadyToShip = order.grossQtyAvailableReadyToShip;
		const qtyAvailableInTransit = order.grossQtyAvailableInTransit;
		const qtyDelivered = order.grossQtyDelivered;
		switch (quantityName) {
		case 'ordered':
			return qtyOrdered || 0;
		case 'inProduction':
			return qtyInProduction || 0;
		case 'readyToShip':
			return qtyAvailableReadyToShip || 0;
		case 'inTransit':
			return qtyAvailableInTransit || 0;
		default:
			return qtyDelivered || 0;
		}
	}

	checkCddWeekData() {
		return this.orderService.checkCddWeekData(this.order.cddWeek);
	}
}
